function applyDeliveryEstimateStyle(textNode) {
  if (!(textNode instanceof Text)) return false;

  const raw = textNode.nodeValue || '';
  const match = raw.match(/Delivery\s+between\s+([A-Za-z]{3,9})\s+0?(\d{1,2})\s+and\s+([A-Za-z]{3,9})\s+0?(\d{1,2})/i);
  if (!match) return false;

  textNode.nodeValue = raw.replace(
    match[0],
    `Delivery ${match[1]} ${Number(match[2])}–${match[3]} ${Number(match[4])}`
  );

  const textElement = textNode.parentElement;
  if (!textElement) return true;

  textElement.style.setProperty('font-size', '15px', 'important');
  textElement.style.setProperty('line-height', '1.35', 'important');
  textElement.style.setProperty('letter-spacing', '0', 'important');

  textElement.querySelectorAll('span, strong, em, b').forEach((element) => {
    element.style.setProperty('font-size', 'inherit', 'important');
    element.style.setProperty('line-height', 'inherit', 'important');
  });

  let row = textElement;
  for (let i = 0; i < 5 && row.parentElement; i += 1) {
    if (row.querySelector('svg') || row.parentElement.querySelector('svg')) {
      if (!row.querySelector('svg')) row = row.parentElement;
      break;
    }
    row = row.parentElement;
  }

  row.classList.add('cm-pdp-delivery-estimate');
  row.style.setProperty('font-size', '15px', 'important');
  row.style.setProperty('line-height', '1.35', 'important');
  row.style.setProperty('margin-top', '8px', 'important');
  row.style.setProperty('margin-bottom', '4px', 'important');
  row.style.setProperty('gap', '8px', 'important');
  row.style.setProperty('min-height', '0', 'important');
  row.style.setProperty('padding-top', '0', 'important');
  row.style.setProperty('padding-bottom', '0', 'important');

  row.querySelectorAll('svg').forEach((icon) => {
    icon.style.setProperty('width', '20px', 'important');
    icon.style.setProperty('height', '20px', 'important');
    icon.style.setProperty('min-width', '20px', 'important');
    icon.style.setProperty('flex-basis', '20px', 'important');
  });

  return true;
}

function scanDeliveryEstimate(root) {
  if (!root) return false;

  const roots = [root];
  let changed = false;

  while (roots.length) {
    const current = roots.pop();
    if (!current) continue;

    const walker = document.createTreeWalker(current, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (applyDeliveryEstimateStyle(node)) changed = true;
    }

    const elements = current.querySelectorAll?.('*') || [];
    for (const element of elements) {
      if (element.shadowRoot) roots.push(element.shadowRoot);
    }
  }

  return changed;
}

function setupDeliveryEstimateRefinement() {
  const run = () => scanDeliveryEstimate(document.body || document.documentElement);

  queueMicrotask(run);
  requestAnimationFrame(run);
  setTimeout(run, 250);
  setTimeout(run, 900);

  const root = document.documentElement;
  if (!root) return;

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      run();
    });
  });

  observer.observe(root, { childList: true, subtree: true });
}

setupDeliveryEstimateRefinement();

import { StandardEvents } from '@shopify/events';

class CantemiriInfo extends HTMLElement {
  #eventTarget;

  connectedCallback() {
    this.#eventTarget = this.closest('.shopify-section, dialog');
    this.#eventTarget?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);

  }

  disconnectedCallback() {
    this.#eventTarget?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (!detail.newProduct && detail.productId && this.dataset.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const blockId = this.dataset.blockId;
        if (!blockId) return;

        const newInfo = detail.html.querySelector(`cantemiri-info[data-block-id="${blockId}"]`);
        if (!newInfo) return;

        this.replaceWith(newInfo);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[cantemiri-info] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('cantemiri-info')) {
  customElements.define('cantemiri-info', CantemiriInfo);
}
